import React from 'react';
import PropTypes from 'prop-types';
import MediaCentralUrl from 'utils/MediaCentralUrl';

class MediaCentralImage extends React.Component {
  // TODO Add properties for accessability [AUTHOR-3317]
  static propTypes = {
    className: PropTypes.string,
    crop: PropTypes.object,
    onImageLoaded: PropTypes.func,
    scaleX: PropTypes.number,
    scaleY: PropTypes.number,
    src: PropTypes.string.isRequired,
  }

  className() {
    let className = 'img-responsive';
    if (this.props.className !== undefined) {
      className += ` ${this.props.className}`;
    }
    return className;
  }

  buildImageUrl() {
    const url = new MediaCentralUrl(this.props.src);
    url.scaleX(this.props.scaleX);
    url.scaleY(this.props.scaleY);
    if (this.props.crop !== undefined) {
      url.crop(this.props.crop.x, this.props.crop.y, this.props.crop.width, this.props.crop.height);
    }
    return url;
  }

  render() {
    return (
      <img
        onLoad={this.props.onImageLoaded}
        src={this.buildImageUrl()}
        className={this.className()}
      />
    );
  }
}

export default MediaCentralImage;
